import { Select } from "antd";

const Option = Select.Option;

const StatusSelect = ({ variables, setVariables }) => {
  const onChange = (value) => {
    if (value === "CURRENT_TASKS") {
      setVariables({ ...variables, statuses: ["IN_PROGRESS", "CREATED"] });
    } else {
      const statusValue = value === "" ? null : [value];
      setVariables({ ...variables, statuses: statusValue });
    }
  };

  return (
    <Select
      showSearch
      showAction={["focus", "click"]}
      data-cy="statusSelect"
      style={{ width: "100%" }}
      onChange={onChange}
      value={
        variables?.statuses?.length > 1 ||
        (variables.statuses?.includes("IN_PROGRESS") &&
          variables.statuses?.includes("CREEATED"))
          ? "CURRENT_TASKS"
          : variables?.statuses?.[0] || ""
      }
    >
      <Option data-cy="ALL" value="">
        All Statuses
      </Option>
      <Option data-cy="CREATED" value="CREATED">
        Created
      </Option>
      <Option data-cy="COMPLETE" value="COMPLETE">
        Complete
      </Option>
      <Option data-cy="WONT_COMPLETE" value="WONT_COMPLETE">
        Won't Complete
      </Option>
      <Option data-cy="CANCELLED" value="CANCELLED">
        Canceled
      </Option>
      <Option data-cy="IN_PROGRESS" value="IN_PROGRESS">
        In Progress
      </Option>
      <Option data-cy="CURRENT_TASKS" value="CURRENT_TASKS">
        Current Tasks
      </Option>
    </Select>
  );
};

export default StatusSelect;
